import { CreateNS } from '../lib/createAPIBuilder';

export const installAPIDevMode = (namespace: CreateNS) => {
    namespace('devMode')(({ func, prop, deps }) => {
        func('enable', deps.enableDevMode);
        func('disable', deps.disableDevMode);
        func('setOptimizelyLogLevel', deps.optimizely.setOptimizelyLogLevel);
        func(
            'setFeaturevisorLogLevels',
            deps.featurevisor.setFeaturevisorLogLevels,
        );

        prop('isDevModeEnabled', deps.getDevMode, null);
        prop('featurevisorInstance', deps.featurevisorInstance, null);
    });
};
